import React from 'react';

const Loader: React.FC = () => {
  return (
    <div className="overflow-hidden bg-white-0.0 animate-pulse sm:px-6 lg:px-8 px-4 py-8">
      <div className="sm:px-6 px-4 py-8 bg-white-3.0 rounded" />
      <div className="flex mt-6 ml-6 bg-white-3.0" />
      <div className="mt-10">
        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 px-4 py-5 border-b-2  border-white-1.0">
          <div className=" bg-white-3.0 rounded py-5" />
        </div>
        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 px-4 py-5 border-b-2 border-white-1.0">
          <div className=" bg-white-3.0 rounded py-5" />
        </div>
        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 px-4 py-5 border-b-2 border-white-1.0">
          <div className=" bg-white-3.0 rounded py-5" />
        </div>
        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 px-4 py-5 border-b-2 border-white-1.0">
          <div className=" bg-white-3.0 rounded py-5" />
        </div>
        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 px-4 py-5 border-b-2 border-white-1.0">
          <div className=" bg-white-3.0 rounded py-5" />
        </div>
        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 px-4 py-5 border-b-2 border-white-1.0">
          <div className=" bg-white-3.0 rounded py-5" />
        </div>
        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 px-4 py-5 border-b-2 border-white-1.0">
          <div className=" bg-white-3.0 rounded py-5" />
        </div>
      </div>
    </div>
  );
};

export default Loader;
